<template>
  <div class="modal is-active">
    <div class="modal-background" />
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Copy from existing filing
        </p>
        <button
          id="modal-close-btn"
          type="button"
          class="delete"
          aria-label="close"
          @click="$emit('close')"
        />
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-12">
            <p>If your filing information hasn't changed much since last year then copying it can save you some time. Would you like to copy the information from <b>{{ lastYear }}'s filing</b> to this new filing? </p>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          id="modal-yes-btn"
          type="button"
          class="button is-primary"
          :class="isCopyingTrue ? 'is-loading' : ''"
          :disabled="isCopyingTrue"
          @click="copyFromFiling(true)"
        >
          Yes
        </button>
        <button
          id="modal-no-btn"
          type="button"
          class="button is-dark"
          :class="isCopyingFalse ? 'is-loading' : ''"
          :disabled="isCopyingFalse"
          @click="copyFromFiling(false)"
        >
          No
        </button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CopyFilingFrom',
  props: {
    lastYear: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  data() {
    return {
      isCopyingTrue: false,
      isCopyingFalse: false,
    };
  },
  methods: {
    copyFromFiling (answer) {
      if (answer) {
        this.isCopyingTrue = true;
      } else {
        this.isCopyingFalse = true;
      }
      this.$parent.$emit('answer', answer);
    },
  },
};
</script>